import { render } from "./youtubeIconB.vue?vue&type=template&id=0b20ebc2"
import script from "./youtubeIconB.vue?vue&type=script&lang=js"
export * from "./youtubeIconB.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__